<!--suppress ALL -->

<template>
  <el-dialog top="10px" title="图片预览" :visible.sync="dialogVisible" :append-to-body="true">
    <el-button class="btn" @click="downloadFile(dialogImageUrl)" style="margin-bottom: 20px">下载图片
    </el-button>
    <el-button type="default" @click="dialogVisible=false" style="margin-left: 20px">关闭
    </el-button>
    <img width="100%" :src="dialogImageUrl" alt="">
    <div slot="footer"></div>
  </el-dialog>


</template>


<script>
export default {
  name: 'ImageBrowser',
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
    }
  },
  components: {},
  methods: {

    show(url) {
      this.dialogVisible = true
      this.dialogImageUrl = url;
    },

    downloadFile(file) {
      window.location.href = file;
    },
  }

}
</script>
